/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_3_LocationInputs */

const en_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const nl_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pl_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fi_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const da_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const sv_landing_testimonial_3_location = /** @type {(inputs: Landing_Testimonial_3_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

/**
* | output |
* | --- |
* | "" |
*
* @param {Landing_Testimonial_3_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_3_location = /** @type {((inputs?: Landing_Testimonial_3_LocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_3_LocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_3_location(inputs)
	if (locale === "fr") return fr_landing_testimonial_3_location(inputs)
	if (locale === "es") return es_landing_testimonial_3_location(inputs)
	if (locale === "it") return it_landing_testimonial_3_location(inputs)
	if (locale === "nl") return nl_landing_testimonial_3_location(inputs)
	if (locale === "pl") return pl_landing_testimonial_3_location(inputs)
	if (locale === "fi") return fi_landing_testimonial_3_location(inputs)
	if (locale === "da") return da_landing_testimonial_3_location(inputs)
	if (locale === "sv") return sv_landing_testimonial_3_location(inputs)
	return en_landing_testimonial_3_location(inputs)
});